<template>
    <div class="customer-choice">
        <div class="title">300万客户的共同选择</div>
        <div class="cards-container">
            <div class="card" :class="{ active: currentCard === 'fresh' }" @click="switchCard('fresh')">
                <div class="card-title">花卉果蔬保鲜</div>
                <div class="card-subtitle">新鲜水果花卉保存</div>
            </div>
            <div class="card" :class="{ active: currentCard === 'plant' }" @click="switchCard('plant')">
                <div class="card-title">植物保护市场</div>
                <div class="card-subtitle">打药杀虫</div>
            </div>
            <div class="card" :class="{ active: currentCard === 'animal' }" @click="switchCard('animal')">
                <div class="card-title">动物生存环境</div>
                <div class="card-subtitle">动物家禽环境如养殖场养猪场等</div>
            </div>
        </div>
        <div class="showcase">
            <div class="showcase-image">
                <img :src="currentCardContent.tabs.image" alt="">
                <div class="tabs">
                    <div class="tab" :class="{ active: currentTab === 'fresh' }" @click="switchTab('fresh')">{{
                        currentCardContent.tabs.fresh.label }}</div>
                    <div class="tab" :class="{ active: currentTab === 'sterilize' }" @click="switchTab('sterilize')">{{
                        currentCardContent.tabs.sterilize.label }}</div>
                </div>
            </div>
            <div class="showcase-content" :style="{ background: currentCardContent.tabs.background }">
                <div class="content-wrapper">
                    <div class="content-title">{{ currentContent.title }}</div>
                    <div class="content-subtitle">{{ currentContent.subtitle }}</div>
                    <div class="stats">
                        <div class="stat-card" v-for="(stat, index) in currentContent.stats" :key="index">
                            <div class="stat-value">
                                {{ stat.value }}
                                <span class="arrow">↑</span>
                            </div>
                            <div class="stat-label">{{ stat.label }}</div>
                        </div>
                    </div>
                    <div class="description">
                        {{ currentContent.description }}
                    </div>
                    <div class="more-btn" @click="goToDynamic(currentContent.urlid)">
                        <span>查看更多</span>
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            currentTab: 'fresh',
            currentCard: 'fresh',
            cardContents: {
                plant: {
                    tabs: {
                        fresh: {
                            label: '施药',
                            title: '精准施药，病害速消',
                            subtitle: '智能化植保解决方案',
                            stats: [
                                { value: '90%', label: '病害防治效果提升' },
                                { value: '40%', label: '药剂用量节省' }
                            ],
                            description: '喷雾设备精准靶向，将药剂均匀喷洒至植株，有效抑制各类植物病害的蔓延。',
                            urlid: "catalogId=647112235761733&id=647113607766085"

                        },
                        sterilize: {
                            label: '除虫',
                            title: '强力除虫，植保无忧',
                            subtitle: '高效防虫害一体化方案',
                            stats: [
                                { value: '95%', label: '害虫消杀率达' },
                                { value: '70%', label: '害虫复发率降低 ' }
                            ],
                            description: '设备喷雾强劲，能快速覆盖害虫藏匿处，高效驱离并消灭害虫。',
                            urlid: "catalogId=647112235761733&id=647113991696453"

                        },
                        image: require('../assets/home32.png'),
                        background: "#325651"
                    }
                },
                fresh: {
                    tabs: {
                        fresh: {
                            label: '保鲜',
                            title: '细腻喷雾，鲜度长留',
                            subtitle: '花卉果蔬保鲜技术',
                            stats: [
                                { value: '6 天', label: '保鲜时长平均延长' },
                                { value: '50%', label: '果蔬失重率降低 ' }
                            ],
                            description: '喷雾设备出雾细腻，均匀包裹花卉果蔬，减缓水分流失，保持新鲜状态。',
                            urlid: "catalogId=647112235761733&id=647112609607749"

                        },
                        sterilize: {
                            label: '抑菌',
                            title: '喷雾抑菌，品质如初',
                            subtitle: '花卉果蔬抑菌技术',
                            stats: [
                                { value: '80%', label: '微生物滋生量减少' },
                                { value: '65%', label: '外观瑕疵率降低 ' }
                            ],
                            description: '利用设备喷洒抑菌剂，有效抑制微生物滋生，维持花卉果蔬的良好品质。',
                            urlid: "catalogId=647112235761733&id=647112316969029"

                        },
                        image: require('../assets/home26.png'),
                        background: "#303E00",
                    }
                },
                animal: {
                    tabs: {
                        fresh: {
                            label: '消毒',
                            title: '全面喷雾，环境无菌',
                            subtitle: '动物环境消毒方案',
                            stats: [
                                { value: '98%', label: '病菌杀灭率达' },
                                { value: '50%', label: '环境消毒时间缩短 ' }
                            ],
                            description: '设备能大面积喷雾消毒，迅速覆盖动物生活区域，杀灭各类病菌。',
                            urlid: "catalogId=647112235761733&id=647115012628549"

                        },
                        sterilize: {
                            label: '除臭',
                            title: '喷雾除味，清新环境',
                            subtitle: '动物环境除臭方案',
                            stats: [
                                { value: '90%', label: '异味去除率' },
                                { value: '60%', label: '动物应激反应减少' }
                            ],
                            description: '通过喷雾释放除臭因子，快速分解异味，改善动物生存环境的空气质量。',
                            urlid: "catalogId=647112235761733&id=647114881982533"

                        },
                        image: require('../assets/home31.png'),
                        background: "#303E00"

                    }
                }
            }
        }
    },
    computed: {
        currentCardContent() {
            return this.cardContents[this.currentCard];
        },
        currentContent() {
            return this.currentCardContent.tabs[this.currentTab];
        }
    },
    created() {
        // this.getNews()
    },
    methods: {
        switchTab(tab) {
            this.currentTab = tab
        },
        switchCard(card) {
            this.currentCard = card
            // 切换卡片时重置为第一个标签
            this.currentTab = 'fresh'
        },
        async getNews() {
            try {
                const res = await this.$http.get('/cms/content/front-list?pageNum=1&pageSize=10&catalogId=646393094279237');

                if (res.code === 200 && res.data.rows) {
                    // 处理每个内容项
                    for (const item of res.data.rows) {
                        // 获取详细内容
                        const detailRes = await this.$http.get(`/cms/content/detail/646393094279237/article/${item.contentId}`);

                        if (detailRes.code === 200) {
                            const detail = detailRes.data;
                            let cardKey;

                            // 根据标题判断对应的卡片类型
                            if (item.title.includes('花卉果蔬')) {
                                cardKey = 'fresh';
                            } else if (item.title.includes('植物保护')) {
                                cardKey = 'plant';
                            } else if (item.title.includes('动物生存')) {
                                cardKey = 'animal';
                            }

                            if (cardKey) {
                                // 更新对应卡片的内容
                                this.cardContents[cardKey].tabs.fresh = {
                                    title: detail.title,
                                    subtitle: detail.subTitle,
                                    stats: this.cardContents[cardKey].tabs.fresh.stats, // 保持原有的统计数据
                                    description: detail.contentHtml.replace(/<[^>]+>/g, '') // 移除HTML标签
                                };
                            }
                        }
                    }
                }
            } catch (error) {
                console.error('获取数据失败:', error);
                // 保持默认数据
            }
        },
        goToDynamic(urlid = 'catalogId=647112235761733&id=647112316969029') {
            console.log(urlid)
            const params = new URLSearchParams(urlid); // 使用 URLSearchParams 解析 urlid
            const catalogId = params.get('catalogId');
            const id = params.get('id');
            this.$router.push({ path: '/news/detail', query: { catalogId, id } }); // 传递拆分后的参数
        },
    }
}
</script>

<style scoped>
.customer-choice {
    width: 100%;
    background: #FFFFFF;
}

.title {
    padding-top: 100px;
    font-size: 40px;
    color: #041214;
    font-weight: bold;
    text-align: center;
}

.cards-container {
    padding-top: 60px;
    display: flex;
    justify-content: space-between;
    width: 1460px;
    margin: 0 auto;
}

.card {
    width: 470px;
    height: 88px;
    border-radius: 12px;
    padding: 18px 0;
    cursor: pointer;
    transition: all 0.3s ease;
}

.card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card.active {
    background: #29AB0B;
}

.card.active .card-title {
    color: #FFFFFF;
}

.card.active .card-subtitle {
    color: #BFE5B6;
}

.card {
    background: #EBEBEB;
}

.card.light {
    background: #F5F6F7;
}

.card-title {
    font-size: 20px;
    color: #000000;
    font-weight: bold;
    text-align: center;
}

.card-subtitle {
    font-size: 15px;
    font-weight: 400;
    text-align: center;
    color: #464646;
}

.showcase {
    width: 1460px;
    margin: 43px auto;
    height: 542px;
    background: #F5F6F7;
    display: flex;
}

.showcase-image {
    width: 885px;
    height: 543px;
    position: relative;
}

.tabs {
    display: flex;
    position: absolute;
    bottom: 23px;
    right: 97px;
}

.tab {
    cursor: pointer;
    transition: all 0.3s ease;
    margin: 0 52px 0 0;
    padding-bottom: 6px;
    color: rgba(255, 255, 255, 0.6);
}

.tab:hover {
    opacity: 0.8;
}

.tab.active {
    height: 33px;
    border-bottom: 3px solid #FFFFFF;
    width: 32px;
    text-align: center;
    color: #FFFFFF;
}

.showcase-content {
    width: 576px;
    height: 542px;
    background: #303E00;
    margin-left: -1px;
}

.content-wrapper {
    padding-top: 87px;
    padding-left: 58px;
}

.content-title {
    font-size: 32px;
    color: #FFFFFF;
    font-weight: 600;
}

.content-subtitle {
    margin-top: 8px;
    color: #FFFFFF;
    font-size: 16px;
}

.stats {
    display: flex;
    margin-top: 30px;
}

.stat-card {
    position: relative;
    width: 180px;
    height: 100px;
    margin-left: 16px;
}

.stat-card:first-child {
    margin-left: 0;
}

.stat-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.1) 100%);
    border-radius: 8px;
    border: 1px solid #FFFFFF;
    opacity: 0.34;
}

.stat-value {
    margin-top: 12px;
    color: #FFFFFF;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    position: relative;
}

.arrow {
    position: absolute;
    top: -10px;
    right: 41px;
}

.stat-label {
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
}

.description {
    font-size: 16px;
    color: #FFFFFF;
    width: 457px;
    margin-top: 17px;
}

.more-btn {
    margin: 30px 0 0 0;
    text-align: center;
    font-size: 16px;
    color: #DCDED4;
    border: 1px solid #FFFFFF;
    border-radius: 20px;
    width: 148px;
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
}

.more-btn i {
    margin-left: 0px;
}

.more-btn span {
    line-height: 1;
}

.more-btn:hover {
    background: rgba(255, 255, 255, 0.1);
}

@media screen and (max-width: 768px) {
    .title {
        padding-top: 40px;
        font-size: 28px;
    }

    .cards-container {
        padding-top: 30px;
        width: 100%;
        flex-direction: column;
        align-items: center;
    }

    .card {
        width: 90%;
        margin-bottom: 15px;
    }

    .showcase {
        width: 100%;
        height: auto;
        flex-direction: column;
        margin: 20px auto;
    }

    .showcase-image {
        width: 100%;
        height: auto;
    }

    .showcase-image img {
        width: 100%;
        height: auto;
    }

    .tabs {
        right: 20px;
        bottom: 15px;
    }

    .showcase-content {
        width: 100%;
        height: auto;
        padding-bottom: 30px;
    }

    .content-wrapper {
        padding: 30px 20px;
    }

    .content-title {
        font-size: 24px;
    }

    .stats {
        flex-direction: column;
    }

    .stat-card {
        width: 100%;
        margin-left: 0;
        margin-bottom: 15px;
    }

    .description {
        width: 100%;
        font-size: 14px;
    }

    .more-btn {
        margin: 20px auto 0;
    }
}
</style> 